import { render } from "./InspecaoSecao6.vue?vue&type=template&id=237467de&scoped=true&ts=true"
import script from "./InspecaoSecao6.vue?vue&type=script&lang=ts"
export * from "./InspecaoSecao6.vue?vue&type=script&lang=ts"

import "./InspecaoSecao6.vue?vue&type=style&index=0&id=237467de&scoped=true&lang=css"

import exportComponent from "D:\\RopeSeguros\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-237467de"]])

export default __exports__